import { useEffect, useState } from "react"

/** Debounces a rapidly-changing value (the command palette's search box,
 *  `FR-DSH-SHL-04`'s own "server-side with debounce"). */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebounced(value)
    }, delayMs)
    return () => {
      clearTimeout(timer)
    }
  }, [value, delayMs])

  return debounced
}
